import { z } from 'my-zod'
import { assetFamilyView } from './asset-family-view'
import { MarketingIconOptions } from '../model-family/marketing-icons'

export const advAssetFamilyView = assetFamilyView.omit({ deletedDate: true }).augment({
  marketingShortDescription: z.string().max(250).nullish(),
  descriptorIcon1: z.enum(MarketingIconOptions).nullish(),
  descriptorIcon2: z.enum(MarketingIconOptions).nullish(),
  descriptionIcon1Text: z.string().nullish(),
  descriptionIcon2Text: z.string().nullish()
})

export type advAssetFamilyView = z.infer<typeof advAssetFamilyView>
